import { CircularProgress, List, makeStyles, PlaceholderBookingHistoryIcon, Theme } from '@freighthub/silhouette-core'
import { CarbonOffsetStrategy, IQuoteSheet, useCustomerPreference } from 'features/BookingFlow'
import { defaultsDeep } from 'lodash-es'
import { FC, MouseEvent, useContext } from 'react'
import { useI18n } from 'utils/localisation'

import { EmptyViewWithIcon } from '../EmptyViewWithIcon'
import { NewQuoteButtonContext } from './NewQuoteButtonContext'
import { RecentQuotesListItem } from './RecentQuotesListItem'

export const testIds = {
  loader: 'recent-quotes-list-loader',
  empty: 'recent-quotes-list-empty',
  list: 'recent-quotes-list-root',
}

const useStyles = makeStyles<Theme>(() => ({
  list: {
    height: '100%',
    width: '100%',
  },
}))

export interface RecentQuotesListProps {
  onClickItem: () => void
}

export const RecentQuotesList: FC<RecentQuotesListProps> = ({ onClickItem }) => {
  const classes = useStyles({})
  const { translate } = useI18n()
  const { recentQuotes, isLoading, requestQuote } = useContext(NewQuoteButtonContext)
  const { customerPreference } = useCustomerPreference()

  const offsettingOptedInByDefault =
    customerPreference?.sustainability?.offsetShipmentsByDefault === CarbonOffsetStrategy.All

  const handleClickItem = (_event: MouseEvent<HTMLDivElement>, quoteSheet: IQuoteSheet) => {
    // TODO: move to a reusable context
    const isOffsettingSupportedForTypeAndMode =
      quoteSheet.request.type === 'fcl' &&
      quoteSheet.request.modes.length === 1 &&
      quoteSheet.request.modes[0] === 'sea'

    // if default offsetting is enabled, we want to override the exisiting recent quote searches that didn't have offsetting enabled
    if (isOffsettingSupportedForTypeAndMode && offsettingOptedInByDefault) {
      const updatedQuoteSheet = defaultsDeep(
        {
          request: { services: { carbonOffset: { offsetStrategy: CarbonOffsetStrategy.All } } },
        },
        quoteSheet
      )

      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      requestQuote(updatedQuoteSheet)
    } else {
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      requestQuote(quoteSheet)
    }

    onClickItem()
  }

  if (isLoading) {
    return <CircularProgress data-testid={testIds.loader} />
  }

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  if (recentQuotes.length === 0) {
    return (
      <EmptyViewWithIcon
        icon={<PlaceholderBookingHistoryIcon />}
        text={translate('recent_searches-no_recent')}
        data-testid={testIds.empty}
      />
    )
  }

  return (
    <List className={classes.list} disablePadding data-testid={testIds.list}>
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      {recentQuotes.map((quoteSheet) => (
        <RecentQuotesListItem key={quoteSheet._id} quoteSheet={quoteSheet} onClick={handleClickItem} />
      ))}
    </List>
  )
}
